import styled, { keyframes } from 'styled-components'

const slideFromZero = progress => keyframes`
  from {
    width: 0;
  }

  to {
    width: ${progress || 0}%;
    }
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const ProgressBar = styled.div`
  display: flex;
  width: ${props => props?.progress || 0}%;
  min-width: ${props => props.theme.size.L};
  background-color: ${props => props?.barColor || props.theme.colors.outline.default};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  justify-content: flex-end;
  border-radius: ${props => props.theme.primitives.radius.radius1};
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp8};
  color: ${props => props?.textColor || props.theme.colors.text.default};
  animation-name: ${props => slideFromZero(props?.progress)};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
`
